<template>
  <b-nav-item-dropdown right no-caret id="dropdown">
    <template slot="button-content">
      <span style="width: 100px" :title="$t('label_snapshotSelector_company')">
        <img
          :src="'/static/icons/icon_organization.svg'"
          height="25"
        />
        <i style="color: #6F3996" class="bi bi-caret-down-fill"></i>
      </span>
    </template>
    <div>
      <div id="search-bar">
        <b-input-group>
              <b-input-group-prepend is-text>
                <icon class="fa-icon-nuevo" name="search"/>
              </b-input-group-prepend>
          <b-form-input @input="filterItems()"
            autofocus
            :placeholder="$t('label_evaluation_search_placeholder')"
            v-model="search" />
        </b-input-group>
      </div>
      <div id="item-list" v-for="(company, index) in filteredItems" :key="index">
        <b-dropdown-item
          @click="updateBusiness(company)"
        >
          <b v-if="currentBusiness.name === company.name">{{company.name}}</b>
          <div v-else>{{company.name}}</div>
        </b-dropdown-item>
      </div>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "TemplateCompanySelector",
  data: function () {
    return {
      search: '',
      filteredItems: {}
    };
  },
  computed: {
    ...mapGetters(["getUserAccountBusinesses"]),
    ...mapFields(["currentBusiness"]),
  },
  mounted(){
    this.filterItems()
  },
  methods: {
    filterItems(){
      if(this.search != ''){
        this.filteredItems = this.$store.getters.getUserAccountBusinesses.filter((item) => {
         return !item.name.toLowerCase().search(this.search.toLowerCase())
        })
      }
      else{
        this.filteredItems = this.$store.getters.getUserAccountBusinesses
      }
    },
    updateBusiness: function (companny) {
      this.currentBusiness = companny
      this.$store.commit("setReloadSelfAssessment", true);
      setTimeout(() => {
        this.$router.go({
          path: this.$router.path,
          query: {
            t: +new Date(),
          },
        });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>

/* components/template/_template-company-selector.vue */
@import "../../assets/css/variables.scss";

::v-deep .dropdown-menu {
    max-height: 60vh;
    min-width: 700px;
    overflow-y: auto;
  }
#search-bar{
  position: relative;
  top: 0px;
  background-color: #fff;
  padding:0 10px 10px 10px;
  border-bottom: 1px solid #919191
}
b{
  color: $primary-color;
}
@media (max-width: 768px) {
  label {
    display: none;
  }
};
</style>
